import { EnvironmentProviders, Provider } from '@angular/core';
import { MsBreadcrumsService } from '../shared/services/ms-breadcrums/ms-breadcrums.services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'primeng/dynamicdialog';
import { MsToastService } from '../shared/services/ms-toast/ms-toast.services';
import { MsDialogDynamicService } from '../shared/services/ms-dialog-dynamic/ms-dialog-dynamic.services';
import { MsDialogConfirmationService } from '../shared/services/ms-dialog-confirmation/ms-dialog-confirmation.services';
import { MsStoreService } from '../shared/services/ms-store/ms-store.services';
import {
	FilterService,
	GroupService,
	PageService,
	ReorderService,
	SortService,
	ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { MsServiceCoreService } from '../shared/services/ms-service-core/ms-service-core.services';
import { RxStompService } from './socket/RxStompService.service';

export const provideInternalCore = (): (Provider | EnvironmentProviders)[] => {
	return [
		MsServiceCoreService,
		MsBreadcrumsService,
		ConfirmationService,
		MessageService,
		ToastrService,
		DialogService,
		MsToastService,
		MsDialogDynamicService,
		MsDialogConfirmationService,
		MsStoreService,
		PageService,
		SortService,
		FilterService,
		GroupService,
		ToolbarService,
		ReorderService,
		RxStompService,
	];
};
